var Serializable = (function () {
    function Serializable(data) {
        this._data = data;
    }
    Serializable.prototype.toJSON = function () {
        return JSON.stringify(this._data);
    };
    Serializable.prototype.serialize = function () {
        return this._data;
    };
    return Serializable;
}());
export { Serializable };
//# sourceMappingURL=serializable.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@appsignal/core/dist/esm/serializable.js
// module id = 1237
// module chunks = 0